import {
  Form,
  FormField,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
} from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoQuiz, defaultValue } from "@/shared/model/edo-quiz.model";
import {
  createEntity,
  updateEntity,
} from "@/shared/reducers/entities/edo-quiz.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect, useState } from "react";
import { Translate, translate } from "react-jhipster";
import { z } from "zod";

const schema = z.object({
  title: z.string().min(1, "Required"),
  description: z.string().optional(),
});

type FormValues = z.infer<typeof schema>;

interface IEditQuizProps {
  quiz?: IEdoQuiz;
  open: boolean;
  onClose: () => void;
}

const EditQuiz = (props: IEditQuizProps) => {
  const dispatch = useAppDispatch();
  const { loading, updating, updateSuccess } = useAppSelector<
    EntityState<IEdoQuiz>
  >((state) => state.edoQuiz);

  const [form, setForm] = useState<IEdoQuiz>({
    ...defaultValue,
    ...props.quiz,
  });

  const { quiz, open, onClose: handleClose } = props;
  const isNew = form?.id === null || form?.id === undefined;

  useEffect(() => {
    if (quiz) {
      setForm({ ...defaultValue, ...quiz });
    } else {
      setForm({ ...defaultValue });
    }
  }, [quiz]);

  useEffect(() => {
    if (open && updateSuccess) handleClose();
  }, [updateSuccess, open]);

  const saveEntity = (data: FormValues) => {
    const entity = {
      ...form,
      title: data.title,
      description: data.description ?? form.description,
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>
            {translate("edocendoApp.edoQuiz.home.createOrEditLabel")}
          </DialogTitle>
        </DialogHeader>
        {loading && !quiz ? (
          <div className="flex justify-center py-4">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          </div>
        ) : (
          <Form<FormValues>
            id="edit-quiz-form"
            key={`${form.id ?? "new"}-${form.title ?? ""}`}
            schema={schema}
            onSubmit={saveEntity}
            defaultValues={{
              title: form.title ?? "",
              description: form.description ?? "",
            }}
            className="flex flex-col gap-4"
          >
            <div className="grid grid-cols-1 gap-4">
              <FormField
                name="title"
                label={translate("edocendoApp.edoQuiz.title")}
                required
              />
              <FormField
                name="description"
                label={translate("edocendoApp.edoQuiz.description")}
              />
            </div>
          </Form>
        )}
        <DialogFooter>
          <Button variant="outline-solid" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button
            type="submit"
            form="edit-quiz-form"
            disabled={updating}
          >
            <Translate contentKey="entity.action.edit">Modifica</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditQuiz;
